import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/img/arrow_back.svg'
import _imports_1 from '@/assets/img/arrow_forward.svg'


const _hoisted_1 = { class: "productSelectorContainer mt-4" }
const _hoisted_2 = { class: "text" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = { class: "d-flex" }
const _hoisted_5 = { class: "right text-gray me-2" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  class: "copiaContainer",
  ref: "body"
}
const _hoisted_12 = { class: "copiaPostoLabel" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_posto_tavola = _resolveComponent("posto-tavola")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, [
          _createVNode(_component_localized_text, {
            localizedKey: "Copia da un altro posto tavola",
            text: "Copia da un altro posto tavola"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (!_ctx.$store.state.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-link arrow",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.doScroll(-160)))
              }, _hoisted_8),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-link arrow",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.doScroll(160)))
              }, _hoisted_10)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.copyFrom, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "copiaPostoContainer",
          key: item.id
        }, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_localized_text, {
              class: "f_12",
              localizedKey: 'Posto tavola ' + item.id ,
              text: 'Posto tavola ' + item.id 
            }, null, 8, ["localizedKey", "text"])
          ]),
          _createVNode(_component_posto_tavola, {
            class: "postoTavola postoCenter",
            postoId: item.id,
            modelValue: item,
            onClick: ($event: any) => (_ctx.onSelect(item))
          }, null, 8, ["postoId", "modelValue", "onClick"])
        ]))
      }), 128))
    ], 512)
  ]))
}